import { post } from "../axios";
import { ApiResponseStatus } from "../constants/enums";
import { responseIsSuccessful } from "../global-helpers";

export async function getPdfToken(data) {
  return await post(
    "pdf/request-token",
    { pdf_data: data },
    window.localStorage.apiToken
  )
    .then(res => {
      let statusAndPdfToken = {
        status: ApiResponseStatus.ERROR,
        pdfToken: null
      };
      if (responseIsSuccessful(res) && res.data.token) {
        statusAndPdfToken.status = ApiResponseStatus.SUCCESS;
        statusAndPdfToken.pdfToken = res.data.token;
      }
      return statusAndPdfToken;
    })
    .catch(err => {
      console.log(err);
      return { status: ApiResponseStatus.ERROR, pdfToken: null };
    });
}
